import React, { useEffect, useState } from 'react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { CookieChoice, cookieChoiceEvent, readCookieChoice } from './cookieConsent';

const isLocalAnalyticsDisabled = () => (
  process.env.NODE_ENV !== 'production'
  || window.location.hostname === 'localhost'
  || window.location.hostname === '127.0.0.1'
);

const AnalyticsGate = () => {
  const [choice, setChoice] = useState<CookieChoice | null>(readCookieChoice);

  useEffect(() => {
    const onChoice = (event: Event) => setChoice((event as CustomEvent<CookieChoice>).detail);
    window.addEventListener(cookieChoiceEvent, onChoice);
    return () => window.removeEventListener(cookieChoiceEvent, onChoice);
  }, []);

  if (isLocalAnalyticsDisabled()) {
    return null;
  }

  return choice === 'analytics' ? <SpeedInsights /> : null;
};

export default AnalyticsGate;
